var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content d-flex flex-column flex-column-fluid px-3"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }